import React from "react";
import styled from "styled-components";
import { PhotoSeries } from "model/photo_series/PhotoSeries";
import { apiStaticUrlGet } from "common/api/api_common";
import LinkTo from "components/navigation/link/LinkTo";
import PhotoFill from "components/common/view_util/image/PhotoFill";

type Props = {
  photoSeries: PhotoSeries;
};

const PhotoSeriesLiEl = ({ photoSeries }: Props) => {
  const sType = photoSeries.getShortSType();
  const represents = photoSeries.getRepresents();
  const fold = photoSeries.fold;
  const imUrls = represents.map((photo: string) =>
    photo !== "" ? apiStaticUrlGet(`photo-series/${fold}/${photo}`) : ""
  );
  const photoSeriesUrl = `/g/${photoSeries.group}/photo-series/${sType}/${photoSeries.slug}`;
  const PHOTO_FIRST_SIZE = 360;
  const PHOTO_GROUP_SIZE = 150;

  const Photos = [];
  for (let i = 0; i < imUrls.length; i++) {
    const imUrl = imUrls[i];
    if (imUrl) {
      const size = i > 0 ? PHOTO_GROUP_SIZE : PHOTO_FIRST_SIZE;
      Photos.push(
        <LinkTo to={photoSeriesUrl} key={`photo_series_album_link_${i}`}>
          <PhotoFill
            src={imUrls[i]}
            alt={photoSeries.name}
            width={size}
            height={size}
          />
        </LinkTo>
      );
    }
  }

  return (
    <>
      <DivTitle>
        <LinkTo to={photoSeriesUrl}>{photoSeries.name}</LinkTo>
      </DivTitle>
      <DivPhotos>{Photos}</DivPhotos>
    </>
  );
};

const DivTitle = styled.div`
  grid-column: 1 / 2;
`;

const DivPhotos = styled.div`
  grid-column: 2 / 6;
  display: flex;
  align-content: center;
  align-items: center;
  gap: 1rem;
`;

export default PhotoSeriesLiEl;
